// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight___rgYh","containerItemsCenter":"Skeleton_containerItemsCenter__2EyxI"};